import { IMenuGlider } from '@sky-it-livedata/livedata-sports-design-system';
import React, { Suspense } from 'react';

import { IComponentModel } from '../../typings/common-types';
import { validateModel } from '../../utils/props-validator';
import HtmlWrapper from '../html-wrapper/html-wrapper';

const MenuGliderWrapper = React.lazy(() => import('./menu-glider'));

export interface IDynamicMenuGlider extends IComponentModel<IMenuGlider> {
  // eslint-disable-next-line react/require-default-props
  live?: boolean;
}

const DynamicMenuGlider = ({
  /* istanbul ignore next: default value */ model = {},
  /* istanbul ignore next: default value */ query = {},
  /* istanbul ignore next: default value */ children = null,
  /* istanbul ignore next: default value */ live = false,
}: IDynamicMenuGlider) => (
  <Suspense fallback={<HtmlWrapper html={children} />}>
    <MenuGliderWrapper live={live} initialModel={validateModel(model) as IMenuGlider} query={validateModel(query)} />
  </Suspense>
);

export default DynamicMenuGlider;
